// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as NavMenuConfig$Showside from "../../types/NavMenuConfig.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
import * as NavMenu__PreloadHelpers$Showside from "./NavMenu__PreloadHelpers.bs.js";
function useSettings(namespace, attributes) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var fromConfig = Belt_Option.flatMap(match.config.transitiveAccount, function (account) {
    return account.navMenuConfig;
  });
  var fromConfig$1 = Belt_Option.map(fromConfig, function (config) {
    return NavMenuConfig$Showside.mergeAttributes(config, attributes);
  });
  return NavMenu__PreloadHelpers$Showside.getSettings(fromConfig$1, namespace, undefined);
}
export { useSettings };
/* NavMenuConfig-Showside Not a pure module */